import { render, staticRenderFns } from "./AuditReferencesForm.vue?vue&type=template&id=04297aa0&scoped=true&"
import script from "./AuditReferencesForm.vue?vue&type=script&lang=js&"
export * from "./AuditReferencesForm.vue?vue&type=script&lang=js&"
import style0 from "./AuditReferencesForm.vue?vue&type=style&index=0&id=04297aa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04297aa0",
  null
  
)

export default component.exports